import { APIFactory } from '../rest/APIFactory';
import { baseUrlService } from '../rest/BaseUrlService';
import { byLabel } from '../utilities/ILabelValue';
import { Logger } from '../logging/LoggerService';
import { IClientLenderAssociationsRequest } from './interface';
import { ISelectOption } from '../components';

export const getAssociatedLendersAsync = async (clientId: string): Promise<Array<ISelectOption<string>>> => {
  try {
    const result = await APIFactory(baseUrlService.ApiLocation).get(`/lender/v2/admin/client/${clientId}/lenders`);
    return mapLenders(result.data.lenderCompanies);
  } catch (e: any) {
    Logger.error('Error get Client Companies', e);
    throw new Error('Error get Associated Lenders');
  }
};

export const getAssociatedLendersForClientAsync = async (): Promise<Array<ISelectOption<string>>> => {
  try {
    const result = await APIFactory(baseUrlService.ApiLocation).get(`/lender/v1/client/lenders`);
    return mapLenders(result.data.lenderCompanies);
  } catch (e: any) {
    Logger.error('Error get Client Companies', e);
    throw new Error('Error get Associated Lenders');
  }
};

export const updateAssociatedLendersAsync = async (
  clientId: string,
  addLenders: string[],
  removeLenders: string[]
): Promise<Array<ISelectOption<string>>> => {
  try {
    const data: IClientLenderAssociationsRequest = {
      lenderCompanyIdsToAdd: addLenders,
      lenderCompanyIdsToRemove: removeLenders,
    };
    const result = await APIFactory(baseUrlService.ApiLocation).post(
      `/lender/v2/admin/client/${clientId}/lenders`,
      data
    );
    return mapLenders(result.data.lenderCompanies);
  } catch (e: any) {
    Logger.error('Error update list of Associated Lenders', e);
    throw new Error('Error update list of Associated Lenders');
  }
};

interface ILender {
  id: string;
  name: string;
}

const mapLenders = (lenders?: ILender[]) => (lenders || []).map((t) => ({ label: t.name, value: t.id })).sort(byLabel);
